export default __webpack_public_path__ + "static/media/menuIcon.d7d9b179.svg";